import { NotificacionService } from './src/services/notificacion.service';

export const notificacionService = new NotificacionService();

export default notificacionService;
